import React from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaTagsProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

const MetaTags: React.FC<MetaTagsProps> = ({
  title = "2AH - Auvergne Amélioration Habitat",
  description = "2AH - Auvergne Amélioration Habitat : Votre expert en rénovation et amélioration de l'habitat en Auvergne. Services de couverture, isolation, zinguerie et traitement des nuisibles.",
  children
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {children}
    </Helmet>
  );
};

export default MetaTags;
